import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { waterRouteDefinitions } from './WaterRouteDefinitions';

import { generatePageWithTabsRoute } from '../routeGenerator';

const WaterRoutes: RouteObject = generatePageWithTabsRoute(
  'Explore water usage and trends',
  BASE.INTERVAL_DATA_WATER,
  NESTED_ROUTES.INTERVAL_DATA_WATER.USAGE,
  waterRouteDefinitions,
);

export default WaterRoutes;
